import palette from '@lib/core/src/theme/palette';
import { Stack, styled, IconButton as MuiIconButton, alpha } from '@mui/material';
import Typography from '@mui/material/Typography';

import { GAP } from '@/pages/JamiesCapabilities/JamiesCapabilitiesStyles';
import { scrollBreakpoint } from '@/pages/JamiesCapabilities/breakpoints';

export const Container = styled(Stack)(({ theme }) => ({
  width: '100%',
  [scrollBreakpoint(theme)]: {
    height: '50%'
  }
}));

export const BorderWrapper = styled('div')(({ theme }) => ({
  height: `calc(100% - 1vh - 18px)`,
  width: '100%',
  border: `1px solid ${palette.grey[200]}`,
  borderRadius: 8,
  [scrollBreakpoint(theme)]: {
    overflow: 'auto'
  }
}));

export const TableWrapper = styled('div')({
  gap: GAP
});

export const TableGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns:
    'minmax(200px, 3fr) minmax(70px, 1fr) minmax(220px, 1fr) minmax(100px, 1fr) 80px', // icon, name/desc, trigger, status, last edited, actions
  alignItems: 'center',
  width: '100%',
  background: palette.white,
  fontFamily: 'Reddit Sans, sans-serif'
});

export const TableHeader = styled(TableGrid)(({ theme }) => ({
  background: palette.grey[100],
  [scrollBreakpoint(theme)]: {
    paddingRight: '16px'
  }
}));

export const StickyContainer = styled(Stack)({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  background: palette.globalBackground
});

export const TableBody = styled(TableGrid)(({ theme }) => ({
  [scrollBreakpoint(theme)]: {
    overflow: 'auto'
  }
}));

export const HeaderRow = styled('div')({
  display: 'contents'
});

export const CapabilityRow = styled(Stack)({
  display: 'contents',
  minHeight: 70,
  height: 70,
  '&:hover > *': {
    background: alpha(palette.black, 0.02),
    cursor: 'pointer'
  }
});

export const Cell = styled('div')({
  padding: '0 16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'flex',
  alignItems: 'center',
  height: '70px',
  minHeight: '70px',
  justifyContent: 'flex-start',
  textAlign: 'left',
  minWidth: 0,
  borderBottom: `1px solid ${palette.grey[200]}`
});

export const HeaderCell = styled(Cell)({
  height: '30px',
  minHeight: '30px',
  fontSize: 11,
  fontWeight: 500,
  color: palette.grey[400]
});

export const AgentDescriptionText = styled(Typography)({
  fontWeight: 400,
  color: palette.grey[600],
  fontSize: 12,
  lineHeight: 1.3
});

export const Text = styled(Typography)({
  color: palette.black,
  fontSize: 12,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
});

export const SmallText = styled(Typography)({
  color: palette.grey[500],
  fontSize: 11,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
});

export const IconButton = styled(MuiIconButton)({
  padding: '0 3px'
});

export const AgentConfigContainer = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 100,
  backgroundColor: palette.globalBackground,
  width: '100%',
  height: '100%'
});

export const Row = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  minWidth: 0
});

export const NameStack = styled(Stack)({
  minWidth: 0,
  maxWidth: '100%',
  padding: '0 8px'
});

export const IconContainer = styled('div')({
  width: '32px',
  minWidth: '32px',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  backgroundColor: palette.grey[100]
});
